import { forwardRef, useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface Props { children: React.ReactNode; delay?: number; className?: string }

export const Reveal = forwardRef<HTMLDivElement, Props>(({ children, delay = 0, className }, forwardedRef) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = innerRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const setRefs = (node: HTMLDivElement | null) => {
    (innerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) (forwardedRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
  };

  return (
    <div ref={setRefs} className={cn(className)} style={{ animationDelay: `${delay}ms` }}>
      <div className={cn(visible && "fade-in-up")} style={{ animationDelay: `${delay}ms`, opacity: visible ? undefined : 0 }}>
        {children}
      </div>
    </div>
  );
});
Reveal.displayName = "Reveal";
